import axios from 'axios';
//@ts-ignore
import config from 'config/index';
import qs from 'qs';
import { error, isObject } from 'coreutils-js';

function getItemStorage(keyName, defaultValue?) {
	try {
		const value = window.localStorage.getItem(keyName);
		if (value) {
			return JSON.parse(value);
		} else {
			window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
			return defaultValue;
		}
	} catch (err) {
		return defaultValue;
	}
}

export function createBaseInstance(baseURL) {
	const instance = axios.create({
		baseURL,
		timeout: config.request.timeout,
		withCredentials: true,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});

	instance.interceptors.request.use(
		(cfg) => {
			if (cfg.data && isObject(cfg.data)) {
				cfg.data = qs.stringify(cfg.data);
			}

			return cfg;
		},
		(error) => {
			console.error(`${baseURL} =>`, error);
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		(response) =>
			new Promise((resolve, reject) => {
				try {
					const data = response.data;

					resolve(data);
				} catch (err) {
					reject(err);
				}
			}),
		(error) =>
			new Promise((resolve, reject) => {
				reject(error);
			})
	);

	return instance;
}

export function createAuthInstance(baseURL) {
	const instance = axios.create({
		baseURL,
		timeout: config.request.timeout,
		// withCredentials: true,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
	let errorCount = 0;
	const getToken = (callback) => {
		const user = getItemStorage('user');

		if (user) {
			callback(user.access_token);
		} else {
			callback(new Error('Không lấy được token'));
		}
	};

	instance.interceptors.request.use(
		(cfg) =>
			new Promise((resolve) => {
				if (typeof window !== 'undefined') {
					const user = getItemStorage('user');
					cfg.headers['Authorization'] = user?.access_token ? `${user.token_type} ${user?.access_token}` : '';
					// cfg.headers['Authorization'] = 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkMxMkE1MUIyRDFFOURGRENDMjQxMkFEQkIwNUEyRjYyIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2NjgwOTM2NDEsImV4cCI6MTk1MTkxNzY0MSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxIiwiY2xpZW50X2lkIjoiYXBpdXNlciIsImF1ZCI6WyJodHRwOi8vbG9jYWxob3N0OjUwMDEvcmVzb3VyY2VzIiwiYXBpX2F1dGgiXSwic2NvcGUiOlsiYXBpX2F1dGgiXX0.D_CGZCgCrrN7xV9LTxWCZz4P0taVfAmWcon4l4cHkl2SdkxfwGUjhpPO_7N3yKEebAGhT5ALExcUaDV6he-vzuOwCPkketR0YE3KTfJz-BW9oOiR85frp7G-DaFQLNDPB5Yaz_vPWnwAfqIAqyPMff18nfsVTBt0LQuaG77DK_8nTR1QOzxp7qWcTFnNs5duqoRI_3dWODknhjIzQWop3R8xDrZvmjJh3CfPpkO2wNQZx-rG3KcKKavhay-Yp-pKu_N2gmaaWTESfK4DnF7vUaaIARbiMCghqngwH-oyAOTry2CEfzzsmisfX9diUPSYSMRjTcUi5QlfEWN0gIte2g';
				}

				if (cfg.data && isObject(cfg.data)) {
					cfg.data = qs.stringify(cfg.data);
				}

				resolve(cfg);
			}),
		(error) => {
			console.error(`${baseURL} =>`, error);
			return error;
		}
	);

	instance.interceptors.response.use(
		(response) =>
			new Promise((resolve, reject) => {
				errorCount = 0;
				if (!response.data.success && response.data.message) {
					// notification({
					// 	type: 'warn',
					// 	placement: 'topRight',
					// 	message: response.data.message ?? response.data.title,
					// 	title: 'Lỗi'
					// })
				}

				try {
					resolve(response.data);
				} catch (err) {
					reject(err);
				}
			}),
		(error) =>
			new Promise((resolve, reject) => {
				console.error(`${baseURL} =>`, error.response.data);

				try {
					if (error.response.status == 401 && errorCount < config.request.maxRetryError) {
						errorCount += 1;

						getToken((err) => {
							if (err) return reject(err);

							return resolve(instance(error.config));
						});
					} else if (error.response.status == 401) {
						window.location.href = '/logout';
						// errorCount = 0;
						// notification({
						// 	type: 'warn',
						// 	placement: 'topRight',
						// 	message: error.response.data.message ?? error.response.data.title,
						// 	title: error.response.status
						// })
						// return reject(error.response.data.error);
					} else {
						return reject(error.response.data.error);
					}
				} catch (e) {
					return reject(error);
				}
			})
	);

	return instance;
}
